import { pick } from 'lodash';
import { deepGet } from 'bam-deep-get';
import { appendScript } from '../utils/helpers.js';

const dssDataLayerDefaults = {
    campaignCode: '',
    cid: '',
    countryCode: '',
    countryGroup: '',
    deviceAdvertisingId: '',
    deviceLanguage: '',
    dssAccountId: '',
    dssDeviceId: '',
    dssProfileId: '',
    dssSessionId: '',
    logInStatus: '',
    mid: '',
    pageName: '',
    pageURL: '',
    partnerId: '',
    redemptionCode: '',
    swid: '',
    userProductName: '',
    userProductSku: '',
    userSubscriptionState: '',
    userVisitorState: '',
    voucherCode: ''
};

function updateDataLayer() {
    const { contextData, sessionInfo } = window.AnalyticsManager;
    window.dssDataLayer = pick({
        ...dssDataLayerDefaults,
        ...contextData,
        logInStatus: contextData.loggedIn,
        pageName: document.body.getAttribute('data-analytics-pagename'),
        pageURL: window.location.href,
        countryCode: sessionInfo.location.countryCode,
        countryGroup: window.dssMlpConfigs.regionConfig.group
    }, Object.keys(dssDataLayerDefaults));
}

function loadScript() {
    const launchScriptUrl = deepGet(window, 'dssMlpConfigs.adobeLaunchUrl');

    if (launchScriptUrl) {
        appendScript(launchScriptUrl, () => {
            updateDataLayer();
        });
    }
}

export function initAdobeLaunch(withFallbackConsent) {
    if (withFallbackConsent) {
        const cookieBanner = document.getElementById('cookies-banner');

        if (!cookieBanner) {
            loadScript();
        } else {
            cookieBanner.querySelector('#consent-accept').addEventListener('click', () => {
                loadScript();
            });
        }
    } else if (window.dssMlpConfigs.adobeLaunchUrl) {
        updateDataLayer();
    }
}
